import script from "./BucketUpdate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BucketUpdate.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__